export { default } from "./RankChangeIndicatorView";
